import React from 'react';
import styled from 'styled-components';

const PublicFooterStyled = styled.div`
  max-width: 30rem;
  margin: auto;
  padding: 2rem 0;
  text-align: center;
  align-self: flex-end;
  flex: 0;
  .copyright {
    font-size: 0.75rem;
  }
`;

/** Copyright footer shown on public (unauthenticated) pages. */
export const PublicFooter = () => {
  return (
    <PublicFooterStyled className="footer">
      <p className="copyright">Copyright ® {(new Date()).getFullYear()} Luminia LLC. All Rights Reserved.</p>
    </PublicFooterStyled>
  );
};